import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    margin-bottom: 16px;
  `;

  const cardHeader = css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.navy["1"]};
    padding: 0px 16px;
  `;

  const headerRow = css`
    padding: 20px 0 0 20px;
    align-items: center;
  `;

  const title = css`
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: ${theme.colors.navy["1"]};
  `;

  const hr = css`
    margin-left: 30px;
    margin-right: 30px;
  `;

  const section = css`
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 15px;
  `;

  const sectionHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0px;
    cursor: pointer;
  `;

  const sectionTitle = css`
    font-weight: 700;
    font-size: 16px;
    color: ${theme.colors.navy["1"]};
  `;

  const sectionChevron = css`
    color: ${theme.colors.navy["1"]};
    font-size: 20px;
    cursor: pointer;
  `;

  const sectionBody = css`
    margin-top: 5px;
  `;

  const sectionTable = css`
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);

    .collapse > td {
      padding: 0 !important;
    }

    .collapse td > div[data-testid="dataTable"] {
      padding: 0 !important;
    }
  `;

  const detailTable = css`
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};

    td:first-child {
      padding-left: 60px;
    }
  `;

  const hideDetailHead = css`
    thead {
      display: none;
    }
  `;

  const columnWidths = css`
    table {
      table-layout: fixed;
      width: 100%;
    }

    th:first-child,
    td:first-child {
      width: 30%;
    }

    th:nth-child(2),
    td:nth-child(2) {
      width: 30%;
    }

    .cellCol2 > div,
    .cellCol3 > div,
    .cellCol4 > div {
      justify-content: flex-end !important;
    }

    th:nth-child(n + 3),
    td:nth-child(n + 3) {
      text-align: right;
    }
  `;

  const pricingTabs = css`
    .nav-tabs {
      border-bottom: 1px solid ${theme.colors.gray["2"]};
      width: 100%;
      padding: 0px 15px;
    }

    .nav-tabs .nav-link {
      background-color: ${theme.colors.white};
      border: none;
      border-bottom: 4px solid transparent;
      color: #418172;
      font-weight: 400;
      font-size: 16px;
      padding: 10px 16px;
      min-width: 180px;
      text-align: center;
    }

    .nav-tabs .nav-link.active {
      background-color: ${theme.colors.white};
      border: none;
      border-bottom: 4px solid #418172;
      color: #418172;
      font-weight: 600;
    }

    .nav-tabs .nav-link:hover:not(.active) {
      border: none;
      border-bottom: 4px solid ${theme.colors.gray["2"]};
    }

    .tab-content > .tab-pane {
      padding: 0;
    }
  `;

  const tabContent = css`
    padding-top: 16px;
    background-color: ${theme.colors.white};
  `;

  return {
    page,
    card,
    cardHeader,
    headerRow,
    title,
    hr,
    section,
    sectionHeader,
    sectionTitle,
    sectionChevron,
    sectionBody,
    sectionTable,
    detailTable,
    hideDetailHead,
    columnWidths,
    pricingTabs,
    tabContent,
  };
};

export default useStyles;
